<div  role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title pull-left">Importar de SUNAT</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="cancelar()" tabindex="99">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" id="first">
      <form action="" #form="ngForm" autocomplete="off">
        <div class="form-row">
          <div class="col-md-12">
            <div class="input-group m-b-5">
              <label style="margin-right: 1.5rem">R.U.C.</label>
              <input class="form-control form-control-sm m-r-5 col-md-7" id="ruc" name="ruc" [(ngModel)]="ruc"
                type="text" maxlength="11" tabindex="100">
            </div>
          </div>

          <div class="input-group  m-t-5 d-flex bd-highlight mb-3" style="justify-content: space-evenly;">
            <button class="btn btn-primary m-r-5 btn-sm" (click)="importar()" id="btnGuardar" tabindex="102"><i
                class="fas fa-arrow-circle-down"></i>&nbsp;
              Importar</button>
            <button class="btn btn-warning btn-sm" (click)="cancelar()" id="btnCancelar" tabindex="103"><i
                class="fa fa-times-circle"></i>&nbsp;
              Cancelar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>